import { handleJsonResponse, handleFileUploadResponse, getFilterQuery, addSortingQuery, getXsrfToken } from "./api";
import config from '../config'; 
import { getUser } from '../auth';


export async function getSettings() {
    const user = getUser();
    const token = user?.access_token;
    const response = await fetch(`${config.API_URL}/settings`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return await handleJsonResponse(response);
}

export async function saveSettings(settings) {
    const user = getUser();
    const token = user?.access_token;
    
    const response = await fetch(`${config.API_URL}/settings`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-XSRF-TOKEN': getXsrfToken()
        },
        body: JSON.stringify(settings)
    });
    return await handleJsonResponse(response);
    
}